import { ShipInfo } from '@ais-ui/websockets';
import { useGetShipByMmsi } from '@ais-ui/api';
import { LoadingSpinner } from '@ais-ui/ui-core';
import React from 'react';
import { VesselResult } from '@ais-ui/api-spec/shipdb';
import { extractMmsiFromShipInfo } from '../../utils/extractMmsiFromShipInfo';
import { ErrorDisplay } from '@ais-ui/ui-core';
import { usePermissions } from '../../Permissions/PermissionsProvider';
import { AdvancedVesselInformationView } from './AdvancedVesselInformationView';

interface ExtendedVesselAdvancedInformationProps {
  extendedVesselInfo: VesselResult;
}

export const ExtendedVesselAdvancedInformation = ({
  extendedVesselInfo,
}: ExtendedVesselAdvancedInformationProps) => {
  return (
    <AdvancedVesselInformationView
      advancedVessel={extendedVesselInfo?.advancedVessel}
    />
  );
};

interface AdvancedVesselInformationProps {
  shipInfo: ShipInfo;
}

export const AdvancedVesselInformation = ({
  shipInfo,
}: AdvancedVesselInformationProps) => {
  const permissions = usePermissions();
  const hasShipDbPermissions =
    permissions.mdmAdvancedVesselInfo ||
    permissions.mdmRegister ||
    permissions.mdmIntegrity;

  const {
    data: extendedVesselInfo,
    isLoading,
    isError,
  } = useGetShipByMmsi(extractMmsiFromShipInfo(shipInfo), hasShipDbPermissions);

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (isError) {
    return <ErrorDisplay className="h-full pt-60" />;
  }

  if (!extendedVesselInfo) {
    return <ErrorDisplay className="h-full pt-60" />;
  }

  return (
    <AdvancedVesselInformationView
      advancedVessel={extendedVesselInfo.advancedVessel}
    />
  );
};

export { AdvancedVesselInformationView } from './AdvancedVesselInformationView';
export type { AdvancedVesselInformationViewProps } from './AdvancedVesselInformationView';
